import { render, staticRenderFns } from "./LivePortalFrame.vue?vue&type=template&id=7aeef122&scoped=true"
import script from "./LivePortalFrame.vue?vue&type=script&lang=js"
export * from "./LivePortalFrame.vue?vue&type=script&lang=js"
import style0 from "./LivePortalFrame.vue?vue&type=style&index=0&id=7aeef122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeef122",
  null
  
)

export default component.exports